export const blogsTranslation = {
  en: {
    blogs: "Blogs",
    addBlog: "Add Blog",
    editBlog: "Edit Blog",
    updateBlog: "Update Blog",
    addNewBlog: "Add New Blog",
    titleEN: "Title EN",
    titleAR: "Title AR",
    image: "Image",
    slug: "Slug",
    descriptionEN: "Description EN",
    descriptionAR: "Description AR",
    "Are you sure you want to delete blog '{{title}}'?":
      "Are you sure you want to delete blog '{{title}}'?",
    actionCannotBeUndone: "This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
    "Are you sure want to delete": "Are you sure you want to delete?",
  },
  ar: {
    blogs: "المدونات",
    addBlog: "إضافة مدونة",
    editBlog: "تحرير المدونة",
    updateBlog: "تحديث المدونة",
    addNewBlog: "إضافة مدونة جديدة",
    titleEN: "العنوان EN",
    titleAR: "العنوان AR",
    image: "الصورة",
    slug: "الرابط الثابت",
    descriptionEN: "الوصف EN",
    descriptionAR: "الوصف AR",
    "Are you sure you want to delete blog '{{title}}'?":
      "هل أنت متأكد أنك تريد حذف المدونة '{{title}}'؟",
    actionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء.",
    cancel: "إلغاء",
    delete: "حذف",
    "Are you sure want to delete": " هل أنت متأكد أنك تريد الحذف؟",
  },
};
